import { useCallback, useState } from 'react';

export function useInputState<T = string>(
    initialState: T
): [T, (e: React.ChangeEvent<{ value: T }>) => void] {
    const [state, setState] = useState<T>(initialState);
    const onChange = useCallback((e: React.ChangeEvent<{ value: T }>) => setState(e.target.value), []);

    return [state, onChange];
}
